<template>
  <a-form ref="formRef" :model="formState" layout="vertical" class="prescription-module">
    <!-- 诊断信息 -->
    <a-row :gutter="16" type="flex" justify="space-between" align="bottom">
      <a-col :span="24">
        <a-form-item
          name="allDiagnose"
          :rules="[
            {
              required: true,
              message: '请选择诊断',
              trigger: ['change', 'blur'],
              type: 'array'
            }
          ]"
        >
          <template v-slot:label>
            <div class="diagnosis-header">
              <span>诊断</span>
              <div class="diagnosis-actions">
                <a
                  v-if="!showNote"
                  class="diagnosis-action"
                  href="javascript:;"
                  @click="toggleNote"
                >
                  添加备注
                </a>
                <a
                  v-if="!showComplaint"
                  class="diagnosis-action"
                  href="javascript:;"
                  @click="toggleComplaint"
                >
                  添加主诉
                </a>
              </div>
            </div>
          </template>
          <div class="diagnose">
            <a-select
              style="width: 100%"
              v-model:value="formState.allDiagnose"
              :mode="'multiple'"
              placeholder="搜索诊断"
              show-search
              :max-tag-count="DIAGNOSIS_LIMIT"
              @search="getDiagnosisList"
              :labelInValue="true"
              :filter-option="false"
              :options="diagnosis"
              :notFoundContent="'暂无搜索数据，请输入有效内容'"
              @select="handleDiagnoseSelect"
              @change="handleDiagnoseChange"
              :getPopupContainer="trigger => trigger.parentNode"
            >
              <template #option="{ value: val, label, diagnosisType, alias, disabled }">
                <div role="img" :aria-label="val">
                  <div class="optionsClass" :style="{ opacity: disabled ? 0.4 : 1 }">
                    <div class="z-fixed-c">
                      <div
                        v-if="diagnosisType"
                        :class="[diagnosisType == 1 ? 'diagnosisCType' : 'diagnosisZType']"
                      >
                        {{ getDiagnosisName(diagnosisType) }}
                      </div>
                    </div>
                    <div class="diagnosisRight">
                      <div class="elip--multiple diagnosisLabel" style="-webkit-line-clamp: 2">
                        {{ label }}
                      </div>
                      <div v-if="alias" class="diagnosisAlias">{{ alias }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </a-select>
          </div>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row
      v-if="showChineseSyndrome"
      :gutter="16"
      type="flex"
      justify="space-between"
      align="bottom"
    >
      <a-col :span="24">
        <a-form-item
          name="chineseSyndromeList"
          label="中医证型"
          class="form-item"
          :rules="[
            {
              required: true,
              message: '请选择中医证型',
              trigger: ['change', 'blur'],
              type: 'array'
            }
          ]"
        >
          <div class="diagnose">
            <a-select
              show-search
              style="width: 100%"
              v-model:value="formState.chineseSyndromeList"
              :mode="'multiple'"
              placeholder="搜索证型"
              :max-tag-count="DIAGNOSIS_LIMIT"
              :labelInValue="true"
              :filter-option="false"
              :notFoundContent="'暂无搜索数据，请输入有效内容'"
              @search="getChineseSyndromeList"
              @select="handleChineseSyndromeSelect"
              @change="handleChineseSyndromeChange"
              :options="chineseSyndromeOptions"
              :getPopupContainer="trigger => trigger.parentNode"
            >
              <template #option="{ value: val, label, diagnosisType, alias, disabled }">
                <div role="img" :aria-label="val">
                  <div class="optionsClass" :style="{ opacity: disabled ? 0.4 : 1 }">
                    <div class="z-fixed-c">
                      <div
                        v-if="diagnosisType"
                        :class="[diagnosisType == 1 ? 'diagnosisCType' : 'diagnosisZType']"
                      >
                        {{ getDiagnosisName(diagnosisType) }}
                      </div>
                    </div>
                    <div class="diagnosisRight">
                      <div class="elip--multiple diagnosisLabel" style="-webkit-line-clamp: 2">
                        {{ label }}
                      </div>
                      <div v-if="alias" class="diagnosisAlias">{{ alias }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </a-select>
          </div>
        </a-form-item>
      </a-col>
    </a-row>
    <a-form-item v-if="showNote" name="remark" class="form-item" label="备注">
      <a-textarea
        v-model:value="formState.remark"
        class="note-input"
        placeholder="请输入备注"
        :maxlength="200"
        showCount
        :auto-size="{ minRows: 2, maxRows: 4 }"
      />
    </a-form-item>
    <a-form-item v-if="showComplaint" name="mainComplaint" class="form-item" label="主诉">
      <a-textarea
        v-model:value="formState.mainComplaint"
        placeholder="请填写患者的症状、体征、持续时间等"
        :maxlength="100"
        showCount
        :auto-size="{ minRows: 2, maxRows: 4 }"
      />
    </a-form-item>
    <!-- Rp 药品列表 -->
    <a-form-item class="form-item" required style="width: 100%">
      <template v-slot:label>
        <div class="prescription-header" @click.prevent="e => e.stopPropagation()">
          <div>药品/健康用品</div>
          <div class="prescription-header__actions">
            <a-button v-if="!showFee" type="primary" ghost @click="toggleFee">添加诊疗费</a-button>
            <a-button v-if="!showAdvice" type="primary" ghost @click="toggleAdvice">
              添加嘱托
            </a-button>
          </div>
        </div>
      </template>
      <div class="prescription-table">
        <div class="prescription-table__actions">
          <div class="prescription-table__left">
            <a-button type="primary" @click="openMedicineDrawer">
              <PlusOutlined :style="{ fontSize: '15px' }" />
              添加药品/健康用品
            </a-button>
            <a-button
              class="prescription-table__recommend-btn"
              :disabled="!formState.diagnosisVOList.length"
              @click="openRecommendDrawer"
            >
              <PlusOutlined :style="{ fontSize: '15px' }" />
              添加推荐方
            </a-button>
          </div>
          <div
            class="prescription-table__right"
            :class="{ disabled: skuInfoList.length === 0 }"
            @click="handleRemoveAll"
          >
            全部删除
          </div>
        </div>
        <div
          v-for="(item, index) in skuInfoList"
          :key="item.skuCode || index"
          class="prescription-table__row"
        >
          <div class="col name">{{ item.skuName }}</div>
          <div class="col qty">
            <div class="qty-control">
              <a-button @click="decreaseItem(item)">-</a-button>
              <a-input-number
                :value="item.quantity"
                class="qty-input"
                :min="1"
                :max="999"
                :precision="0"
                :controls="false"
                :parser="value => value.replace(/\D/g, '')"
                @change="value => updateItemQuantity(index, value)"
              />
              <a-button @click="increaseItem(item)">+</a-button>
            </div>
          </div>
          <div class="col action">
            <a class="remove" href="javascript:;" @click="removeItem(index)">删除</a>
            <!-- 协定方不展示说明书 -->
            <a
              v-if="item.skuType !== 7"
              class="leaflet"
              href="javascript:;"
              @click="openLeaflet(item)"
            >
              药品说明书
            </a>
          </div>
        </div>
        <div v-if="skuInfoList.length === 0" class="prescription-table__empty">
          暂无药品，请添加
        </div>
      </div>
    </a-form-item>
    <a-form-item
      v-if="showFee"
      :name="['recommendCureParamVO', 'payAmountYuan']"
      class="form-item"
      label="诊疗费"
      ref="feeFormRef"
    >
      <a-input
        :value="storeCureFee"
        placeholder="请输入诊疗费"
        :maxlength="20"
        readonly
        addon-after="元 / 次"
        @click="openFeeModal"
      />
    </a-form-item>
    <a-form-item v-if="showAdvice" name="advice" class="form-item" label="嘱托" ref="adviceFormRef">
      <a-input
        :value="storeAdvice"
        placeholder="请输入嘱托"
        :maxlength="200"
        readonly
        @click="openAdviceModal"
      />
    </a-form-item>

    <!-- 预约复诊 -->
    <a-row :gutter="16" type="flex" justify="space-between" align="bottom">
      <a-col :span="24">
        <a-form-item name="retreatment">
          <div class="retreatContent">
            <div class="reHead">
              <div>
                <span class="retreatTit">预约复诊</span>
                <span class="tips">请添加复诊时分别向医生/患者确认复诊日期</span>
              </div>
            </div>
            <div class="reContent">
              <a-form-item
                class="item"
                :name="['revisitRemindInfo', 'reserveDate']"
                label="复诊日期"
                :rules="[
                  {
                    required: !formState.revisitRemindInfo.notNeedReserve,
                    message: '请选择复诊日期',
                    trigger: ['change', 'blur']
                  }
                ]"
              >
                <div class="date-picker-wrapper">
                  <a-date-picker
                    style="width: 180px"
                    v-model:value="formState.revisitRemindInfo.reserveDate"
                    @change="setTreatDate"
                    :disabled-date="disabledDate"
                    :showToday="false"
                  >
                    <template #dateRender="{ current }">
                      <div :class="['ant-calendar-date', calendarCustomStyle(current)]">
                        {{ current.date() }}
                      </div>
                    </template>
                    <template #renderExtraFooter>
                      <div class="date-picker-shortcuts">
                        <a-button
                          size="small"
                          type="primary"
                          ghost
                          @click="setRevisitDateByDays(7)"
                        >
                          一周后
                        </a-button>
                        <a-button
                          size="small"
                          type="primary"
                          ghost
                          @click="setRevisitDateByDays(14)"
                        >
                          两周后
                        </a-button>
                        <a-button
                          size="small"
                          type="primary"
                          ghost
                          @click="setRevisitDateByDays(30)"
                        >
                          一个月后
                        </a-button>
                      </div>
                    </template>
                  </a-date-picker>
                </div>
              </a-form-item>
              <a-form-item
                class="item"
                :name="['revisitRemindInfo', 'reserveDateDetail']"
                label="复诊时段"
                :rules="[
                  {
                    required: !formState.revisitRemindInfo.notNeedReserve,
                    message: '请选择复诊时段',
                    trigger: ['change', 'blur'],
                    type: 'number'
                  }
                ]"
              >
                <a-radio-group
                  v-model:value="formState.revisitRemindInfo.reserveDateDetail"
                  @change="changeDateDetailAndType"
                >
                  <a-radio :value="1">上午</a-radio>
                  <a-radio :value="2">下午</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                class="item"
                :name="['revisitRemindInfo', 'revisitType']"
                label="复诊方式"
                :rules="[
                  {
                    required: !formState.revisitRemindInfo.notNeedReserve,
                    message: '请选择复诊方式',
                    trigger: ['change', 'blur'],
                    type: 'number'
                  }
                ]"
              >
                <a-radio-group
                  v-model:value="formState.revisitRemindInfo.revisitType"
                  @change="changeDateDetailAndType"
                >
                  <a-radio :value="1">线上咨询</a-radio>
                  <a-radio :value="2">门诊就诊</a-radio>
                </a-radio-group>
              </a-form-item>
            </div>
          </div>
          <div class="line"></div>
          <div class="notreatBox">
            <div class="notreat">
              <a-checkbox
                v-model:checked="formState.revisitRemindInfo.notNeedReserve"
                @change="hanldeCheck"
              >
                遵医嘱复诊
              </a-checkbox>
            </div>
          </div>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>

  <MedicineDrawer :visible="medicineDrawerVisible" @close="closeMedicineDrawer" />
  <RecommendDrawer
    :visible="recommendDrawerVisible"
    :diagnosisVOList="formState.diagnosisVOList"
    @close="closeRecommendDrawer"
  />

  <FeeModal
    v-model:visible="feeModalVisible"
    v-model:value="feeInput"
    @confirm="handleFeeConfirm"
    @cancel="handleFeeCancel"
  />
  <AdviceModal
    v-model:visible="adviceModalVisible"
    v-model:selected="adviceSelected"
    v-model:advice="adviceInput"
    @confirm="handleAdviceConfirm"
    @cancel="handleAdviceCancel"
  />
  <MedicineLeafletDrawer
    :visible="leafletVisible"
    :doctor-id="leafletDoctorId"
    :sku-code="leafletSkuCode"
    @close="closeLeaflet"
  />
</template>

<script setup>
import { reactive, ref, defineExpose, computed, onMounted, watch, nextTick, toRaw } from 'vue'
import { useStore } from 'vuex'
import { debounce } from 'lodash-es'
import { getDiagnosis } from '@/api/HealthRecord/index.js'
import moment from 'moment'
import { queryCureReserveTag } from '@/api/workPlace/retreatment.js'
import { Modal, message } from 'ant-design-vue'
import MedicineDrawer from './Medicin/MedicineDrawer.vue'
import RecommendDrawer from './Medicin/RecommendDrawer.vue'
import FeeModal from './Medicin/FeeModal.vue'
import AdviceModal from './Medicin/AdviceModal.vue'
import MedicineLeafletDrawer from './Medicin/MedicineLeafletDrawer.vue'
import { PlusOutlined } from '@ant-design/icons-vue'
// 诊断最多选择数量
const DIAGNOSIS_LIMIT = 10

// 表单实例与局部显隐控制
const formRef = ref()
const adviceFormRef = ref()
const feeFormRef = ref()
// 备注显示控制
const showNote = ref(false)
// 主诉显示控制
const showComplaint = ref(false)
// 诊疗费显示控制
const showFee = ref(false)
// 诊疗费弹窗显示
const feeModalVisible = ref(false)
// 诊疗费输入值
const feeInput = ref('')
// 嘱托显示控制
const showAdvice = ref(false)
// 嘱托弹窗显示
const adviceModalVisible = ref(false)
// 嘱托多选值
const adviceSelected = ref([])
// 嘱托说明输入
const adviceInput = ref('')
// 药品说明书抽屉
const leafletVisible = ref(false)
const leafletSkuCode = ref('')
const leafletDoctorId = computed(() => store.state.preMedicalRecord?.doctorId ?? '')
// 药品抽屉显隐
const medicineDrawerVisible = ref(false)
// 推荐方抽屉显隐
const recommendDrawerVisible = ref(false)
// 全局 store
const store = useStore()
// 诊断候选数据
const diagnosis = ref([])
// 优先从预病历 store 取 ucId，缺省时取工单信息
const storeUcDoctorId = computed(() => store.state.preMedicalRecord?.ucDoctorId ?? null)
// 患者 ucId
const storeUcPatientId = computed(() => store.state.preMedicalRecord?.ucPatientId ?? null)
// 诊疗费与嘱托只读展示（来自 store）
const storeCureFee = computed(
  () => store.state.preMedicalRecord?.recommendCureParamVO?.payAmountYuan ?? ''
)
// 嘱托 = taboo + advice 拼接展示
const storeAdvice = computed(() => {
  const taboo = store.state.preMedicalRecord?.taboo ?? ''
  const advice = store.state.preMedicalRecord?.advice ?? ''
  return [taboo, advice].filter(Boolean).join(';')
})
//不可选日期
const disabledDate = current => {
  return current && current < moment()
}

// 诊断类型文案
const getDiagnosisName = type => {
  if (type === 1) {
    return '西医'
  } else if (type === 2) {
    return '中医'
  }
  return ''
}
// 表单状态
const formState = reactive({
  allDiagnose: [],
  diagnosisVOList: [],
  chineseSyndromeList: [],
  remark: '',
  mainComplaint: '',
  recommendCureParamVO: {
    payAmountYuan: ''
  },
  revisitRemindInfo: {
    reserveDate: null,
    reserveDateDetail: null,
    revisitType: null,
    notNeedReserve: false,
    modifyReserveDateFlag: 1
  }
})

// 表单校验规则已内联到各表单项

// 药品列表
const skuInfoList = computed(() => store.state.preMedicalRecord?.skuInfoList || [])

// 协定方存在时显示中医证型
const showChineseSyndrome = computed(() => skuInfoList.value.some(item => item?.skuType === 7))

// 中医证型选项（搜索接口）
const chineseSyndromeOptions = ref([])

// 限制中医证型最多选择数量
const handleChineseSyndromeSelect = () => {
  if (formState.chineseSyndromeList.length > DIAGNOSIS_LIMIT) {
    formState.chineseSyndromeList = formState.chineseSyndromeList.slice(0, DIAGNOSIS_LIMIT)
    message.warning(`中医证型最多选择${DIAGNOSIS_LIMIT}条`)
  }
}

// 中医证型变更时清理校验提示
const handleChineseSyndromeChange = () => {
  formRef.value?.clearValidate?.(['chineseSyndromeList'])
}
// 诊断变更时清理校验提示
const handleDiagnoseChange = () => {
  formRef.value?.clearValidate?.(['allDiagnose'])
}
// 同步中医证型到 store（避免重复写入导致递归更新）
const isSameChineseList = (a = [], b = []) => {
  if (a.length !== b.length) return false
  return a.every((item, index) => {
    const target = b[index]
    return (
      String(item?.id ?? '') === String(target?.id ?? '') &&
      String(item?.name ?? '') === String(target?.name ?? '') &&
      Number(item?.diagnosisType ?? 2) === Number(target?.diagnosisType ?? 2)
    )
  })
}
// 同步中医证型到 store
const syncChineseSyndromeVOList = () => {
  const list = (formState.chineseSyndromeList || []).map(item => ({
    id: item.value,
    name: item.label,
    diagnosisType: 2
  }))
  const current = store.state.preMedicalRecord?.chineseDiagnosisVOList || []
  if (isSameChineseList(list, current)) return
  store.dispatch('preMedicalRecord/updatePreMedicalRecord', {
    chineseDiagnosisVOList: list
  })
}
// 监听中医证型变更同步到 store
watch(
  () => formState.chineseSyndromeList,
  () => {
    syncChineseSyndromeVOList()
  },
  { deep: true }
)
// 从 store 同步中医证型到表单
watch(
  () => store.state.preMedicalRecord?.chineseDiagnosisVOList,
  nextList => {
    if (!Array.isArray(nextList)) {
      formState.chineseSyndromeList = []
      return
    }
    const newValue = nextList
      .map(item => ({
        value: item?.id ?? '',
        label: item?.name || '',
        diagnosisType: 2
      }))
      .filter(item => item.value !== '')
    // 仅在内容不同时才更新，避免触发同步 watch
    if (JSON.stringify(formState.chineseSyndromeList) !== JSON.stringify(newValue)) {
      formState.chineseSyndromeList = newValue
    }
  },
  { immediate: true }
)

// 协定方移除时同步清空中医证型
watch(
  () => skuInfoList.value,
  nextList => {
    const hasProtocol = (nextList || []).some(item => item?.skuType === 7)
    if (!hasProtocol) {
      formState.chineseSyndromeList = []
      const current = store.state.preMedicalRecord?.chineseDiagnosisVOList || []
      if (current.length) {
        store.dispatch('preMedicalRecord/updatePreMedicalRecord', {
          chineseDiagnosisVOList: []
        })
      }
    }
  },
  { deep: true }
)

// 更新处方药品列表
const updateSkuInfoList = nextList => {
  store.dispatch('preMedicalRecord/updatePreMedicalRecord', {
    skuInfoList: nextList
  })
}

// 减少药品数量
const decreaseItem = item => {
  if (item.quantity <= 1) return
  const nextList = skuInfoList.value.map(current =>
    current === item ? { ...current, quantity: current.quantity - 1 } : current
  )
  updateSkuInfoList(nextList)
}

// 增加药品数量
const increaseItem = item => {
  const nextList = skuInfoList.value.map(current =>
    current === item ? { ...current, quantity: (current.quantity || 0) + 1 } : current
  )
  updateSkuInfoList(nextList)
}

// 删除单项药品（带确认）
const removeItem = index => {
  const item = skuInfoList.value[index]
  if (!item) return
  Modal.confirm({
    title: '确定删除此药品？',
    okText: '确认',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      const nextList = skuInfoList.value.filter((_, idx) => idx !== index)
      updateSkuInfoList(nextList)
    }
  })
}

// 手动设置药品数量
const updateItemQuantity = (index, value) => {
  const nextValue = Math.max(1, Math.min(999, Number(value) || 1))
  const nextList = skuInfoList.value.map((item, idx) =>
    idx === index ? { ...item, quantity: nextValue } : item
  )
  updateSkuInfoList(nextList)
}

// 全部删除（带确认）
const handleRemoveAll = () => {
  if (skuInfoList.value.length === 0) return
  Modal.confirm({
    title: '确认是否清空处方',
    okText: '确认',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      updateSkuInfoList([])
    }
  })
}

// 限制诊断最多选择数量
const handleDiagnoseSelect = () => {
  if (formState.allDiagnose.length > DIAGNOSIS_LIMIT) {
    formState.allDiagnose = formState.allDiagnose.slice(0, DIAGNOSIS_LIMIT)
    message.warning(`诊断最多选择${DIAGNOSIS_LIMIT}条`)
  }
}

// 将选择的诊断同步为接口所需结构
const syncDiagnosisVOList = () => {
  formState.diagnosisVOList = (formState.allDiagnose || []).map(item => {
    const matched = diagnosis.value.find(option => option.value === item.value)
    return {
      id: item.value,
      name: item.label,
      diagnosisType: item?.diagnosisType ?? matched?.diagnosisType ?? 1
    }
  })
  // 同步到 store
  store.dispatch('preMedicalRecord/updatePreMedicalRecord', {
    diagnosisVOList: formState.diagnosisVOList
  })
}

watch(
  () => formState.allDiagnose,
  () => {
    syncDiagnosisVOList()
  },
  { deep: true }
)

// 从 store 同步诊断到表单（推荐方/药品带入诊断时保持回显与校验一致）
watch(
  () => store.state.preMedicalRecord?.diagnosisVOList,
  nextList => {
    if (!Array.isArray(nextList)) {
      formState.allDiagnose = []
      return
    }
    const mapped = nextList
      .map(item => ({
        value: item?.id ?? '',
        label: item?.name || '',
        diagnosisType: item?.diagnosisType
      }))
      .filter(item => item.value !== '')
    const uniq = new Map()
    mapped.forEach(item => {
      if (!uniq.has(String(item.value))) {
        uniq.set(String(item.value), item)
      }
    })
    // 仅在内容不同时才更新，避免触发同步 watch
    const newValue = Array.from(uniq.values())
    if (JSON.stringify(formState.allDiagnose) !== JSON.stringify(newValue)) {
      formState.allDiagnose = newValue
    }
  },
  { immediate: true }
)

// 打开药品抽屉（互斥）
const openMedicineDrawer = () => {
  medicineDrawerVisible.value = true
  recommendDrawerVisible.value = false
}

// 关闭药品抽屉
const closeMedicineDrawer = () => {
  medicineDrawerVisible.value = false
}

// 打开推荐方抽屉（互斥）
const openRecommendDrawer = () => {
  recommendDrawerVisible.value = true
  medicineDrawerVisible.value = false
}

// 关闭推荐方抽屉
const closeRecommendDrawer = () => {
  recommendDrawerVisible.value = false
}

// 打开药品说明书
const openLeaflet = item => {
  if (!item?.skuCode) return
  leafletSkuCode.value = item.skuCode
  leafletVisible.value = true
}

// 关闭药品说明书
const closeLeaflet = () => {
  leafletVisible.value = false
  leafletSkuCode.value = ''
}

// 显示备注输入框
const toggleNote = () => {
  showNote.value = true
}

// 显示主诉输入框
const toggleComplaint = () => {
  showComplaint.value = true
}

// 打开诊疗费弹窗
const openFeeModal = () => {
  feeInput.value = storeCureFee.value ? String(storeCureFee.value) : ''
  feeModalVisible.value = true
}

// 显示诊疗费输入框
const toggleFee = () => {
  showFee.value = true
  // 滚动到诊疗费位置
  nextTick(() => {
    const element = feeFormRef.value?.$el
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  })
}

// 取消诊疗费弹窗
const handleFeeCancel = () => {
  feeModalVisible.value = false
}

// 确认诊疗费并同步到 store
const handleFeeConfirm = () => {
  const nextValue = Number(String(feeInput.value || '').replace(/\D/g, ''))
  const safeValue = Math.max(0, Math.min(5000, Number.isNaN(nextValue) ? 0 : nextValue))
  store.dispatch('preMedicalRecord/updatePreMedicalRecord', {
    recommendCureParamVO: {
      ...(store.state.preMedicalRecord?.recommendCureParamVO || {}),
      payAmountYuan: safeValue
    }
  })
  feeModalVisible.value = false
}

// 显示嘱托输入框
const toggleAdvice = () => {
  showAdvice.value = true
  // 滚动到页面底部
  nextTick(() => {
    const element = adviceFormRef.value?.$el
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  })
}

// 打开嘱托弹窗（带入 store 数据）
const openAdviceModal = () => {
  const taboo = store.state.preMedicalRecord?.taboo ?? ''
  const advice = store.state.preMedicalRecord?.advice ?? ''
  const nextSelected = String(taboo)
    .split(/[,，;；、]/)
    .map(item => item.trim())
    .filter(Boolean)
  adviceSelected.value = nextSelected
  adviceInput.value = advice || ''
  adviceModalVisible.value = true
}

// 取消嘱托弹窗
const handleAdviceCancel = () => {
  adviceModalVisible.value = false
}

// 确认嘱托并同步到 store
const handleAdviceConfirm = () => {
  const tabooValue = (adviceSelected.value || []).join('，')
  store.dispatch('preMedicalRecord/updatePreMedicalRecord', {
    taboo: tabooValue,
    advice: adviceInput.value || ''
  })
  showAdvice.value = true
  adviceModalVisible.value = false
}

// 对外暴露药品明细（Promise）
const getMedicineDetails = async () => {
  if (!skuInfoList.value.length) {
    message.warning('请先添加药品/健康用品')
    return Promise.reject(new Error('未选择药品'))
  }
  try {
    await formRef.value.validate()
  } catch (error) {
    // 校验失败，滚动到第一个错误字段
    const errorElement = formRef.value?.$el?.querySelector('.ant-form-item-has-error')
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    return Promise.reject(error)
  }
  return {
    ...formState,
    skuInfoList: skuInfoList.value,
    recommendCureParamVO: {
      ...(store.state.preMedicalRecord?.recommendCureParamVO || {})
    },
    taboo: store.state.preMedicalRecord?.taboo ?? '',
    advice: store.state.preMedicalRecord?.advice ?? ''
  }
}

const getFormData = () => {
  return {
    ...toRaw(formState),
    skuInfoList: [...(skuInfoList.value || [])],
    recommendCureParamVO: {
      ...(store.state.preMedicalRecord?.recommendCureParamVO || {})
    },
    taboo: store.state.preMedicalRecord?.taboo ?? '',
    advice: store.state.preMedicalRecord?.advice ?? ''
  }
}

const setFormData = data => {
  const draft = data || {}
  const diagnosisList = draft.diagnosisVOList || []
  const chineseDiagnosisList = draft.chineseDiagnosisVOList || []
  formState.allDiagnose = diagnosisList
    .map(item => ({
      value: item?.id,
      label: item?.name,
      diagnosisType: item?.diagnosisType
    }))
    .filter(item => item.value !== undefined && item.value !== null)
  formState.chineseSyndromeList = chineseDiagnosisList
    .map(item => ({
      value: item?.id,
      label: item?.name,
      diagnosisType: item?.diagnosisType ?? 2
    }))
    .filter(item => item.value !== undefined && item.value !== null)
  formState.remark = draft.remark || ''
  formState.mainComplaint = draft.mainComplaint || ''
  formState.revisitRemindInfo = {
    ...formState.revisitRemindInfo,
    ...(draft.revisitRemindInfo || {})
  }
  formState.recommendCureParamVO = {
    ...formState.recommendCureParamVO,
    ...(draft.recommendCureParamVO || {})
  }
  showNote.value = !!formState.remark
  showComplaint.value = !!formState.mainComplaint
  showFee.value = !!(
    draft.recommendCureParamVO && draft.recommendCureParamVO.payAmountYuan !== null
  )
  showAdvice.value = !!(draft.taboo || draft.advice)
}

// 预约复诊列表
const appointList = ref([])
// 获取复诊日期列表
const fetchReverseList = () => {
  appointList.value = []
  const params = {
    ucPatientId: storeUcPatientId.value || null,
    reserveDateMin: null,
    reserveDateMax: null,
    ucDoctorId: storeUcDoctorId.value || null,
    prescribe: true
  }
  queryCureReserveTag(params)
    .then(result => {
      appointList.value = result || []
    })
    .catch(error => {
      console.error('获取复诊日期列表失败:', error)
      appointList.value = []
    })
}

// 日历样式：根据是否可预约标记不同颜色
const calendarCustomStyle = computed(() => {
  return function (current) {
    let className = null
    className = ''
    const curD = moment(current).format('YYYY-MM-DD')
    const date = appointList.value.find(f => f.reserveDate === curD)
    if (date) {
      className = date.reserveTag === 1 ? 'calendar-custom' : 'calendar-custom-passed'
    }
    return className
  }
})

// 无需复诊时清空并清理校验
const hanldeCheck = () => {
  if (formState.revisitRemindInfo.notNeedReserve) {
    formState.revisitRemindInfo.reserveDate = null
    formState.revisitRemindInfo.reserveDateDetail = null
    formState.revisitRemindInfo.revisitType = null
    formRef.value?.clearValidate?.([
      ['revisitRemindInfo', 'reserveDate'],
      ['revisitRemindInfo', 'reserveDateDetail'],
      ['revisitRemindInfo', 'revisitType']
    ])
  }
  syncRevisitRemindInfo()
}

// 复诊日期变更：格式化并标记已修改
const setTreatDate = value => {
  formState.revisitRemindInfo.notNeedReserve = false
  formState.revisitRemindInfo.modifyReserveDateFlag = 1
  formState.revisitRemindInfo.reserveDate = value
    ? moment(value).format('YYYY-MM-DD 00:00:00')
    : null
  syncRevisitRemindInfo()
}

// 通过天数快捷设置复诊日期
const setRevisitDateByDays = days => {
  const nextDate = moment().add(days, 'days')
  formState.revisitRemindInfo.reserveDate = nextDate.format('YYYY-MM-DD 00:00:00')
  formState.revisitRemindInfo.notNeedReserve = false
  formState.revisitRemindInfo.modifyReserveDateFlag = 1
  syncRevisitRemindInfo()
}

// 复诊时段/方式变更时重置“无需复诊”
const changeDateDetailAndType = () => {
  formState.revisitRemindInfo.notNeedReserve = false
  syncRevisitRemindInfo()
}

// 同步复诊信息到 store
const syncRevisitRemindInfo = () => {
  store.dispatch('preMedicalRecord/updatePreMedicalRecord', {
    revisitRemindInfo: { ...formState.revisitRemindInfo }
  })
}

// 获取诊断数据（防抖 + 兜底）
const getDiagnosisList = debounce(async e => {
  const params = {
    page: 1,
    num: 500,
    keyword: e,
    chineseMedicine: 0
  }
  try {
    const res = await getDiagnosis(params)
    if (res[0] && res[0].result.length > 0) {
      diagnosis.value = res[0].result.map(item => ({
        label: item.name,
        value: item.id,
        diagnosisType: item.diagnosisType, //改前：1-中医诊断，0-西医诊断 // 改后：2-中医诊断，1-西医诊断
        alias: item.alias
      }))
      return
    }
    diagnosis.value = []
  } catch (error) {
    diagnosis.value = []
  }
}, 300)

// 获取中医证型（防抖）
const getChineseSyndromeList = debounce(async e => {
  const params = {
    page: 1,
    num: 500,
    keyword: e,
    chineseMedicine: 1
  }
  try {
    const res = await getDiagnosis(params)
    if (res[0] && res[0].result.length > 0) {
      chineseSyndromeOptions.value = res[0].result.map(item => ({
        label: item.name,
        value: item.id,
        diagnosisType: item.diagnosisType,
        alias: item.alias
      }))
      return
    }
    chineseSyndromeOptions.value = []
  } catch (error) {
    chineseSyndromeOptions.value = []
  }
}, 300)
// 初始化：加载可预约复诊日期
onMounted(() => {
  if (String(storeCureFee.value || '').trim()) {
    showFee.value = true
  }
  fetchReverseList()
})
// 暴露给父组件的校验方法
defineExpose({ getMedicineDetails, getFormData, setFormData })
</script>

<style scoped lang="scss">
.prescription-module {
  background: #eceef5;
  padding: 14px 20px 14px 20px;
  ::v-deep(.ant-form-item-required) {
    width: 100%;
  }
  ::v-deep(.ant-form-item-label > label) {
    width: 100%;
    font-weight: 500;
  }
  ::v-deep(.ant-btn) {
    padding: 0 12px;
    height: 28px;
  }
}

.prescription-module__actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

/* 诊断区域 */
.diagnosis-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .diagnosis-actions {
    display: flex;
    align-items: center;
    gap: 24px;
  }
}

.diagnosis-action {
  color: #1989fa;
  font-weight: 400;
  white-space: nowrap;
}

/* 药品列表 */
.prescription-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .prescription-header__actions {
    display: flex;
    gap: 12px;
  }
}

.prescription-table {
  overflow: hidden;
  background: #fff;
}

.prescription-table__actions {
  background: #f7f8fb;
  padding: 12px 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  ::v-deep(.ant-btn > .anticon + span) {
    margin-left: 4px;
  }
  .prescription-table__left {
    display: flex;
    gap: 12px;
    .prescription-table__recommend-btn {
      background: #ff981a;
      border: 1px solid #ff981a;
      color: #fff;
    }
    ::v-deep(.ant-btn[disabled]) {
      color: rgba(0, 0, 0, 0.25);
      background: #f5f5f5;
      border-color: #d9d9d9;
    }
  }
  .prescription-table__right {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
  }
  .prescription-table__right.disabled {
    color: #bfbfbf;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.prescription-table__row {
  display: flex;
  align-items: center;
  padding: 6px 16px;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}

.prescription-table__row:last-child {
  border-bottom: none;
}

.col.name {
  flex: 1;
  margin-right: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col.qty {
  margin-right: 44px;
  display: flex;
  justify-content: left;
}

.col.action {
  width: 140px;
  color: #1890ff;
  text-align: left;
}

.qty-control {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  height: 36px;
  border: 1px solid #d9d9d9;
  ::v-deep(.ant-btn) {
    border: 0;
    height: 100%;
    width: 40px;
  }
  ::v-deep(.ant-input-number) {
    border-top: 0;
    border-bottom: 0;
    border-radius: 0;
  }
  ::v-deep(.ant-input-number-handler-wrap) {
    display: none;
  }
  ::v-deep(.ant-input-number-input) {
    text-align: center;
    height: 34px;
    padding: 0;
  }
}

.qty-input {
  width: 43px;
}

.remove {
  margin-right: 24px;
}

.action-divider {
  margin: 0 6px;
  color: #bfbfbf;
}

.prescription-table__empty {
  padding: 12px;
  color: #999;
  text-align: center;
}

.questionzdClass {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 4px;
  margin-right: 28px;
  font-size: 12px;
  background: #ffa940;
  margin-left: 5px;
  overflow: hidden;
  color: #ffffff;
  font-weight: bold;
}
.formShowTxt {
  font-weight: 400;
  font-size: 12px;
}
.formShowTxtNum {
  font-weight: 400;
  font-size: 14px;
  color: #ffa940;
  font-weight: bold;
}
.diagnose {
  width: 100%;
  border-radius: 4px;
  .diagnoseIN {
    padding: 18px 35px 0px 35px;
  }
  .chooseGrid {
    display: grid;
    grid-template-columns: 89px auto;
    margin-bottom: 17px;
  }
  .atPresent {
    ::v-deep(.ant-tag) {
      border: 0;
      background: #f5f5f5;
    }
  }
  .right {
    .btm {
      margin-bottom: 12px !important;
    }
    .historySpan {
      box-sizing: border-box;
      margin: 0;
      color: rgba(0, 0, 0, 0.85);
      list-style: none;
      font-feature-settings: 'tnum';
      display: inline-block;
      height: auto;
      margin-right: 8px;
      padding: 0 7px;
      font-size: 12px;
      line-height: 20px;
      // white-space: nowrap;
      background: #fafafa;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      opacity: 1;
      transition: all 0.3s;
      cursor: pointer;
    }
  }
}
.optionsClass {
  display: flex;
}
.diagnosisZType {
  min-width: 32px;
  background: #ffffff;
  border: 1px solid #ca9460;
  border-radius: 4px;
  font-weight: 400;
  margin-right: 12px;
  text-align: center;
  font-size: 12px;
  color: #ca9460;
  float: left;
  line-height: 17px;
}
.diagnosisCType {
  min-width: 32px;
  background: #ffffff;
  border: 1px solid #1890ff;
  border-radius: 4px;
  font-weight: 400;
  margin-right: 12px;
  text-align: center;
  font-size: 12px;
  color: #1890ff;
  float: left;
  line-height: 17px;
}
.diagnosisRight {
  display: flow-root;
}
.diagnosisAlias {
  font-size: 12px;
  color: #999999;
}
.diagnosisLabel {
  font-size: 14px;
  color: #333333;
}
.retreatContent {
  width: 100%;
  border-bottom: 10px solid F5F5F5;
  .reHead {
    padding-bottom: 12px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
    justify-content: space-between;
    .retreatTit {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
    }

    .tit {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }
    .tips {
      font-weight: 500;
      font-size: 12px;
      color: #ffa940;
      margin-left: 12px;
    }
    .action {
      width: 328px;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      justify-content: space-evenly;
    }
  }

  .reContent {
    display: flex;
    padding: 15px 15px 0 15px;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    .item:last-of-type {
      margin-right: 0;
    }

    .itlabel {
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      margin-bottom: 8px;
    }
  }
}
.notreatBox {
  background: #fff;
  padding: 0 16px;
  .notreat {
    padding: 15px 0;
    border-top: 1px solid #f0f0f0;
  }
}
.formTitle {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  margin-bottom: 8px;
}

.date-picker-wrapper {
  display: flex;
  align-items: center;
}

.date-picker-shortcuts {
  display: flex;
  gap: 8px;
  padding: 8px;
}
</style>
